import React from "react";

import moment from "moment/moment";
import Flatpickr from "react-flatpickr";

import Modal from 'react-bootstrap/Modal'

import CodeInput from "../item/CodeInput";

import AsyncSelect from "../common/AsyncSelect";

import Backend from "../../../utils/Backend";
import Notify from "../../../utils/Notify";
import General from "../../../utils/General";

export default class Refund extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      show: props.show,
      submission: props.submission,
    }
  }


  _isFormValid(){
    let {
      date,
      amount,
      currency,
      description,
      applicationType,
      legalBasisCode,
      procedureCode,
      customsOfficeOfDebt,
    } = this.state


    let error = null
    if(!date){
      error = "Please select a date"
    }
    else if(!currency){
      error = "Please select a currency"
    }
    else if(!amount){
      error = "Please enter an amount"
    }
    else if(!applicationType){
      error = "Please select an application type"
    }
    else if(!legalBasisCode){
      error = "Please select a legal basis code"
    }
    else if(!procedureCode){
      error = "Please select a procedure code"
    }
    else if(!customsOfficeOfDebt){
      error = "Please select a customs office of debt"
    }
    else if(!description){
      error = "Please enter a description"
    }


    if(error){
      Notify.error(error)
      return false
    }

    return true
  }

  _save(name){
    let {
      submission,
      date,
      amount,
      signature,
      currency,
      description,
      applicationType,
      legalBasisCode,
      procedureCode,
      additionalInformation,
      customsOfficeOfDebt,
      customsOfficeOfResponsibility,
      tickBox
    } = this.state

    if(!this._isFormValid()){
      return
    }

    let data = {
      submission: submission.id,
      documents: []
    }

    if(date){
      data.date = date
    }

    if(amount){
      data.amount = amount
    }

    if(currency){
      data.currency = currency.id
    }

    if(applicationType){
      data.application_type = applicationType.id
    }

    if(legalBasisCode){
      data.legal_basis_code = legalBasisCode.id
    }

    if(procedureCode){
      data.procedure_code = procedureCode.id
    }

    if(applicationType){
      data.application_type = applicationType.id
    }

    if(additionalInformation){
      data.additional_information = additionalInformation
    }

    if(description){
      data.description = description
    }

    if(customsOfficeOfDebt){
      data.customs_office_of_debt = customsOfficeOfDebt
    }

    if(customsOfficeOfResponsibility){
      data.customs_office_of_responsibility = customsOfficeOfResponsibility
    }

    data.tick_box = tickBox
    data.signature = signature

    this.setState({ loading: true })
    Backend.refundApplication(data)
    .then(submission => {
      this.props.onRefundApplicationSent()
      Notify.success("Refund Application Sent!")
      this.setState({ loading: false })
    }).catch(e => {
      Notify.error(e.message)
      this.setState({ loading: false })
    })
  }

  render() {
    let {
      show,
      date,
      loading,
      amount,
      submission,
      signature,
      currency,
      description,
      applicationType,
      legalBasisCode,
      procedureCode,
      additionalInformation,
      customsOfficeOfDebt,
      customsOfficeOfResponsibility,
      tickBox

    } = this.state

    // documents = serializers.JSONField(required=False, allow_null=True)

    // tick_box = serializers.BooleanField(required=False, allow_null=True)

    return (
      <>
        <Modal
          show={show}
          onHide={() => this.props.onHide()}
          className={'sub-modal'}
          dialogClassName={"modal-50"}
        >
          <Modal.Header closeButton>
            <Modal.Title>Refund Application</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="flex-column" data-kt-stepper-element="content">
              <div className="row">

                <div className="col-md-4">
                  <div className="mb-5">
                    <label className={"mb-2"}>Date *</label>
                    <Flatpickr
                      className="form-control"
                      placeholder="Date"
                      value={date}
                      options={{
                        enableTime: true,
                        noCalendar: false,
                        dateFormat: "Y-m-d H:i K"
                      }}
                      onChange={dates => {
                        let date = moment(dates[0]).format('YYYY-MM-DDThh:mm:ss')
                        this.setState({date})
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-4">
                  <CodeInput
                    placeholder={"Currency"}
                    listKey={"Currencies"}
                    value={currency}
                    required={true}
                    editable={true}
                    onSelected={currency => {
                      this.setState({currency})
                    }}
                  />
                </div>

                <div className="col-md-4">
                  <label className="mb-2">Amount Of Duties To Be Repaid *</label>
                  <div className="mb-0">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Amount"
                      value={amount}
                      style={{height: 48}}
                      onChange={e => {
                        this.setState({amount: e.target.value || null})
                      }}
                    />
                  </div>
                  <div className={"text-muted mb-3"} style={{ textAlign: "right" }}>Total Liability: {submission.total_tax_amouht || 0}</div>
                </div>

                <div className="col-md-4">
                  <CodeInput
                    placeholder={"Application Type"}
                    listKey={"AuthorisationTypeCode"}
                    value={applicationType}
                    required={true}
                    editable={true}
                    onSelected={applicationType => {
                      this.setState({applicationType})
                    }}
                  />
                </div>

                <div className="col-md-4">
                  <CodeInput
                    placeholder={"Legal Basis Code"}
                    listKey={"LegalBasisCodes"}
                    value={legalBasisCode}
                    required={true}
                    editable={true}
                    onSelected={legalBasisCode => {
                      this.setState({legalBasisCode})
                    }}
                  />
                </div>

                <div className="col-md-4">
                  <CodeInput
                    placeholder={"Procedure Code"}
                    listKey={"ProcedureCode"}
                    value={procedureCode}
                    required={true}
                    editable={true}
                    onSelected={procedureCode => {
                      this.setState({procedureCode})
                    }}
                  />
                </div>

                <div className="col-md-6">
                  <label className="mb-2">Customs Office of Debt *</label>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Customs Office of Debt"
                      value={customsOfficeOfDebt}
                      style={{height: 48}}
                      onChange={e => {
                        this.setState({customsOfficeOfDebt: e.target.value || null})
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="mb-2">Customs Office of Responsibility</label>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Customs Office of Responsibility"
                      value={customsOfficeOfResponsibility}
                      style={{height: 48}}
                      onChange={e => {
                        this.setState({customsOfficeOfResponsibility: e.target.value || null})
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <label className="mb-2">Description of Grounds *</label>
                  <div className="mb-3">
                    <textarea
                      className="form-control"
                      placeholder="Description of Grounds"
                      value={description}
                      onChange={e => {
                        this.setState({description: e.target.value || null})
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <label className="mb-2">Additional Information</label>
                  <div className="mb-3">
                    <textarea
                      className="form-control"
                      placeholder="Additional Information"
                      value={additionalInformation}
                      onChange={e => {
                        this.setState({additionalInformation: e.target.value || null})
                      }}
                    />
                  </div>
                </div>


              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-primary px-6"
                onClick={() => this._save()}
                disabled={loading}
              >
                Save
              </button>
            </div>
          </Modal.Footer>

        </Modal>
      </>
    )
  }
}

Refund.defaultProps = {}
